import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface CurrentDataSlice {
  loggedInUserData: any;
  forgotPwdEmail: string;
}

const initialState: CurrentDataSlice = {
  loggedInUserData: null,
  forgotPwdEmail: "",
};

const currentDataSlice = createSlice({
  name: "currentData",
  initialState,
  reducers: {
    setLoggedInUserData(state, action: PayloadAction<CurrentDataSlice>) {
      state.loggedInUserData = action.payload;
    },
    clearLoggedInUserData(state) {
      state.loggedInUserData = null;
    },
    setForgotPwdEmail(state, action: PayloadAction<string>) {
      state.forgotPwdEmail = action.payload;
    },
    reset(state) {
      state.loggedInUserData = null;
      state.forgotPwdEmail = "";
    },
  },
});

export const {
  setLoggedInUserData,
  clearLoggedInUserData,
  reset,
  setForgotPwdEmail,
} = currentDataSlice.actions;

export default currentDataSlice.reducer;
